import { JSX } from 'react'

import { IconProps } from '../../icon'

const Detectives: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_885_34)'>
      <path
        d='M8.03333 21.6138L9.30227 23.5684L12.6661 21.3845L11.3971 19.4299L8.03333 21.6138Z'
        fill='#1C485C'
      />
      <path
        d='M0.71579 25.7723C0.71579 25.7723 -0.515306 26.5715 0.283905 27.8026L0.497621 28.1321C0.497621 28.1321 1.29683 29.3632 2.52793 28.564L9.67853 23.9201C9.67853 23.9201 10.028 23.693 9.80097 23.3435L8.44075 21.2509C8.44075 21.2509 8.21368 20.9014 7.86639 21.1284L0.71579 25.7723Z'
        fill='#FAB742'
      />
      <path
        d='M1.7065 28.8334C0.954043 28.8334 0.49767 28.1322 0.49767 28.1322L0.395264 27.9741L9.12647 22.304L9.80324 23.3436C9.8589 23.4304 9.87893 23.5083 9.87893 23.5773C9.87893 23.7888 9.6808 23.918 9.6808 23.918L2.5302 28.5618C2.22744 28.7577 1.95139 28.8334 1.7065 28.8334Z'
        fill='#E6A539'
      />
      <path
        d='M13.0869 14.3986C13.0869 14.3986 14.9057 13.5838 17.0718 13.457C17.448 11.3242 17.6996 10.3202 17.6996 10.3202C17.6996 10.3202 17.92 9.12697 19.2068 9.19153C19.8034 9.28503 20.2108 9.81932 21.4664 9.66126C21.8426 9.63009 22.2188 9.28503 22.5951 9.2227C23.0982 9.19153 23.7237 8.93997 24.1957 10.0709C24.3849 10.6675 24.8858 13.4592 24.8858 13.4592C24.8858 13.4592 29.3939 13.8977 29.3716 15.091C29.3516 16.2842 25.0305 16.8786 22.6062 16.9744C20.1796 17.0679 16.1524 16.9744 13.5076 16.0015C12.7218 15.7166 11.927 15.0264 13.0869 14.3986Z'
        fill='#575756'
      />
      <path
        d='M17.4279 20.5808C17.4279 20.5808 17.094 20.5497 16.4862 19.3876C16.1924 18.6351 16.0054 18.132 16.1924 17.8804C16.3794 17.6311 17.1652 17.5977 17.1652 17.5977C17.1652 17.5977 19.0998 17.6601 20.9298 18.2567C22.0585 17.9739 25.0394 17.2215 25.823 17.8804C25.8853 18.1943 25.7918 18.5394 25.7918 18.5394C25.7918 18.5394 25.2175 20.5163 24.2223 20.7345C24.1912 20.7968 23.1248 21.2999 21.9627 20.5475C21.7112 20.2024 21.4507 19.6681 21.3461 19.4188C21.3683 19.4188 21.3038 18.8221 20.9587 18.8533C20.676 18.9468 20.5825 19.4188 20.5825 19.4188C20.5825 19.4188 20.2998 20.6432 19.2022 20.8613C19.2022 20.8925 18.5744 21.1129 17.9466 20.8613L17.4279 20.5808Z'
        fill='#575756'
      />
      <path
        d='M20.9364 25.0199V26.1575C27.0563 26.1575 32.0141 21.1975 32.0141 15.0799C32.0141 8.96001 27.0563 4 20.9364 4C14.8188 4 9.8588 8.96001 9.8588 15.0799C9.8588 21.1975 14.8188 26.1575 20.9364 26.1575V25.0199V23.8823C18.501 23.8823 16.3081 22.8983 14.7119 21.3044C13.1157 19.7082 12.134 17.5153 12.134 15.0799C12.134 12.6444 13.118 10.4516 14.7119 8.85537C16.3081 7.25918 18.501 6.27742 20.9364 6.27742C23.3697 6.27742 25.5647 7.2614 27.1609 8.85537C28.7571 10.4516 29.7389 12.6466 29.7389 15.0799C29.7389 17.5131 28.7549 19.7082 27.1609 21.3044C25.5647 22.9006 23.3697 23.8823 20.9364 23.8823V25.0199Z'
        fill='#1C485C'
      />
    </g>
    <defs>
      <clipPath id='clip0_885_34'>
        <rect
          width='32'
          height='32'
          fill='white'
          transform='translate(0.0140991)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default Detectives
